import { SubscriptionManagerState } from './state';
import { subscriptionManagerInitialState } from './initial-state';
import { SubscriptionManagerActions } from './action-creators';
import * as actions from './actions';

export const subscriptionManagerReducer = (
  state: SubscriptionManagerState = subscriptionManagerInitialState,
  action: SubscriptionManagerActions
): SubscriptionManagerState => {
  switch (action.type) {
    case actions.LIST_SUBSCRIPTIONS: {
      return {
        ...state,
        summary: undefined,
        loaded: false,
      };
    }

    case actions.LIST_SUBSCRIPTIONS_SUCCESS: {
      return {
        ...state,
        summary: action.summary,
        loaded: true,
      };
    }

    default: {
      return { ...state };
    }
  }
};
